{
    "Orders-Quick-Search-Fields": [
        {
            "label": "Event Type", "columnname": "EventType", "placeholder": "Event Type",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Symbol", "columnname": "Symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "OMS Order ID", "columnname": "OMSOrderID", "placeholder": "OMS Order ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Customer ID", "columnname": "CustomerID", "placeholder": "Customer ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Contra ID", "columnname": "ContraID", "placeholder": "Contra ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Received From MPID", "columnname": "ReceivedFromMPID", "placeholder": "Received From MPID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "OMSSystem", "columnname": "OMSSystem", "placeholder": "OMSSystem",
            "width": "", "datatype": "String", "isLarge": false
        }
    ],
    "Orders-Grid-Columns": [
        {
            "display": "true",
            "ui_columnname": "Event Type",
            "db_columnname": "EventType",
            "datatype": "String",
            "mappingkey": "eventType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ord Date Time",
            "db_columnname": "OrderDateTime",
            "datatype": "String",
            "mappingkey": "orderDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "System Date Time",
            "db_columnname": "SystemDateTime",
            "datatype": "String",
            "mappingkey": "systemDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OMS Order ID",
            "db_columnname": "OMSOrderID",
            "datatype": "String",
            "mappingkey": "oMSOrderId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Order ID",
            "db_columnname": "OrderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "Symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side",
            "db_columnname": "BuySellCode",
            "datatype": "String",
            "mappingkey": "buySellCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ord Qty",
            "db_columnname": "Quantity",
            "datatype": "float",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "MinQuantity",
            "db_columnname": "MinQuantity",
            "datatype": "float",
            "mappingkey": "minQuantity",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ord Price",
            "db_columnname": "LimitPrice",
            "datatype": "Float",
            "mappingkey": "limitPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Price Type",
            "db_columnname": "PriceType",
            "datatype": "char",
            "mappingkey": "priceType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Customer ID",
            "db_columnname": "CustomerID",
            "datatype": "String",
            "mappingkey": "customerID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Contra ID",
            "db_columnname": "ContraID",
            "datatype": "String",
            "mappingkey": "contraID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Received From MPID",
            "db_columnname": "ReceivedFromMPID",
            "datatype": "String",
            "mappingkey": "receivedFromMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CancelOrderID",
            "db_columnname": "cancelOrderID",
            "datatype": "String",
            "mappingkey": "cancelOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Acct Type",
            "db_columnname": "AcctType",
            "datatype": "String",
            "mappingkey": "acctType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TIF",
            "db_columnname": "TimeInForce",
            "datatype": "String",
            "mappingkey": "timeInForce",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NotHeld",
            "db_columnname": "NotHeld",
            "datatype": "String",
            "mappingkey": "notHeld",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Spl. Handling Code",
            "db_columnname": "SplHandlingCode",
            "datatype": "String",
            "mappingkey": "splHandlingCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DNR/DNI",
            "db_columnname": "DoNotReduceIncrease",
            "datatype": "String",
            "mappingkey": "doNotReduceIncrease",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AON",
            "db_columnname": "AllOrNone",
            "datatype": "String",
            "mappingkey": "allOrNone",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TradingSessioncode",
            "db_columnname": "tradingSessionCode",
            "datatype": "String",
            "mappingkey": "tradingSessionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ISO",
            "db_columnname": "iSOInd",
            "datatype": "String",
            "mappingkey": "iSOInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CustomerType",
            "db_columnname": "customerType",
            "datatype": "String",
            "mappingkey": "customerType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AffiliateFlag",
            "db_columnname": "affiliateFlag",
            "datatype": "String",
            "mappingkey": "affiliateFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Bid Price",
            "db_columnname": "BidPrice",
            "datatype": "Float",
            "mappingkey": "bidPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ask Price",
            "db_columnname": "AskPrice",
            "datatype": "Float",
            "mappingkey": "askPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Stop Price",
            "db_columnname": "StopPrice",
            "datatype": "Float",
            "mappingkey": "stopPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Expiry Date",
            "db_columnname": "ExpiryDate",
            "datatype": "Date",
            "mappingkey": "expiryDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Expiry Time",
            "db_columnname": "ExpiryTime",
            "datatype": "String",
            "mappingkey": "expiryTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Limit Order display",
            "db_columnname": "LimitOrderdisplay",
            "datatype": "String",
            "mappingkey": "limitOrderDisplay",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Program Trading",
            "db_columnname": "ProgramTrading",
            "datatype": "String",
            "mappingkey": "programTrading",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Negotiated Trade",
            "db_columnname": "NegotiatedTrade",
            "datatype": "char",
            "mappingkey": "negotiatedTrade",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Solicitation Flag",
            "db_columnname": "solicitationFlag",
            "datatype": "String",
            "mappingkey": "solicitationFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Cancel By Cust",
            "db_columnname": "CancelByCust",
            "datatype": "String",
            "mappingkey": "cancelByCust",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Order Desk",
            "db_columnname": "OrderDesk",
            "datatype": "String",
            "mappingkey": "orderDesk",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Originating Desk",
            "db_columnname": "OriginatingDesk",
            "datatype": "String",
            "mappingkey": "originatingDesk",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Instrument Type",
            "db_columnname": "instrumentType",
            "datatype": "String",
            "mappingkey": "instrumentType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "InfoBarrierId",
            "db_columnname": "InfoBarrierId",
            "datatype": "String",
            "mappingkey": "infoBarrierID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Receive Method",
            "db_columnname": "ReceiveMethod",
            "datatype": "char",
            "mappingkey": "receiveMethod",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Received Order Id",
            "db_columnname": "ReceivedOrderId",
            "datatype": "String",
            "mappingkey": "receivedOrderId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Parent OrderID",
            "db_columnname": "parentOrderID",
            "datatype": "String",
            "mappingkey": "parentOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ParentOrderDate",
            "db_columnname": "parentOrderDate",
            "datatype": "String",
            "mappingkey": "parentOrderDate",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ComplianceOrderID",
            "db_columnname": "complianceOrderID",
            "datatype": "String",
            "mappingkey": "complianceOrderID",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Manual Order ID",
            "db_columnname": "manualOrderId",
            "datatype": "String",
            "mappingkey": "manualOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Manual Order Date",
            "db_columnname": "manualOrderDate",
            "datatype": "String",
            "mappingkey": "manualOrderDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AggOrderID",
            "db_columnname": "aggOrderId",
            "datatype": "String",
            "mappingkey": "aggOrderId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RootOrderID",
            "db_columnname": "rootOrderID",
            "datatype": "String",
            "mappingkey": "rootOrderID",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CancelOrderDate",
            "db_columnname": "cancelOrderDate",
            "datatype": "String",
            "mappingkey": "cancelOrderDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CancelQuantity",
            "db_columnname": "cancelquantity",
            "datatype": "float",
            "mappingkey": "cancelquantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "LeavesQty",
            "db_columnname": "leavesQuantity",
            "datatype": "float",
            "mappingkey": "leavesquantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Position",
            "db_columnname": "Position",
            "datatype": "Int",
            "mappingkey": "position",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ext Destination",
            "db_columnname": "ExtDestination",
            "datatype": "String",
            "mappingkey": "extDestination",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Contra Acct",
            "db_columnname": "ContraAcct",
            "datatype": "String",
            "mappingkey": "contraAcct",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trader Account",
            "db_columnname": "TraderAccount",
            "datatype": "String",
            "mappingkey": "traderAccount",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Capacity",
            "db_columnname": "Capacity",
            "datatype": "String",
            "mappingkey": "capacity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Locate Info",
            "db_columnname": "LocateInfo",
            "datatype": "String",
            "mappingkey": "locateInfo",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Acct. Restrict",
            "db_columnname": "AcctRestrict",
            "datatype": "String",
            "mappingkey": "acctRestrict",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Delivery Instructions",
            "db_columnname": "DeliveryInstructions",
            "datatype": "String",
            "mappingkey": "deliveryInstructions",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Reject Reason",
            "db_columnname": "RejectReason",
            "datatype": "String",
            "mappingkey": "rejectReason",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Cust Rep",
            "db_columnname": "CustRep",
            "datatype": "String",
            "mappingkey": "custRep",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade Along",
            "db_columnname": "TradeAlong",
            "datatype": "String",
            "mappingkey": "tradeAlong",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Strategy",
            "db_columnname": "Strategy",
            "datatype": "String",
            "mappingkey": "strategy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Strategy Details",
            "db_columnname": "StrategyDetails",
            "datatype": "String",
            "mappingkey": "strategyDetails",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Received From System",
            "db_columnname": "ReceivedFromSystem",
            "datatype": "String",
            "mappingkey": "receivedFromSystem",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Bid Size",
            "db_columnname": "BidSize",
            "datatype": "Int",
            "mappingkey": "bidSize",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ask Size",
            "db_columnname": "AskSize",
            "datatype": "Int",
            "mappingkey": "askSize",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderVersionNum",
            "db_columnname": "orderVersionNum",
            "datatype": "String",
            "mappingkey": "orderVersionNum",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Parent Version Num",
            "db_columnname": "parentVersionNum",
            "datatype": "String",
            "mappingkey": "parentVersionNum",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }, {
            "display": "true",
            "ui_columnname": "Info1",
            "db_columnname": "info1",
            "datatype": "String",
            "mappingkey": "info1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Info2",
            "db_columnname": "info2",
            "datatype": "String",
            "mappingkey": "info2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Terminal User",
            "db_columnname": "TerminalUser",
            "datatype": "String",
            "mappingkey": "terminalUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RepresentativeInd",
            "db_columnname": "representativeInd",
            "datatype": "String",
            "mappingkey": "representativeInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trigger Price",
            "db_columnname": "triggerPrice",
            "datatype": "float",
            "mappingkey": "triggerPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ref QuoteID",
            "db_columnname": "RefQuoteID",
            "datatype": "String",
            "mappingkey": "refQuoteID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Classification",
            "db_columnname": "classification",
            "datatype": "String",
            "mappingkey": "classification",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Discretionary",
            "db_columnname": "discretionary",
            "datatype": "String",
            "mappingkey": "discretionary",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderFlags",
            "db_columnname": "orderFlags",
            "datatype": "String",
            "mappingkey": "orderFlags",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderPriceTypeQualifier",
            "db_columnname": "orderPriceTypeQualifier",
            "datatype": "String",
            "mappingkey": "orderPriceTypeQualifier",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CustomerXPPTInfo",
            "db_columnname": "customerXPPTInfo",
            "datatype": "String",
            "mappingkey": "customerXPPTInfo",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "VolumeDone",
            "db_columnname": "volumeDone",
            "datatype": "String",
            "mappingkey": "volumeDone",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "VWAP",
            "db_columnname": "vWAP",
            "datatype": "String",
            "mappingkey": "vWAP",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CompletionReason",
            "db_columnname": "completionReason",
            "datatype": "String",
            "mappingkey": "completionReason",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CompositeOrder",
            "db_columnname": "compositeOrder",
            "datatype": "String",
            "mappingkey": "compositeOrder",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CompositeOrderID",
            "db_columnname": "compositeOrderID",
            "datatype": "String",
            "mappingkey": "compositeOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "LinkedBrokerCapacityID",
            "db_columnname": "linkedBrokerCapacityID",
            "datatype": "String",
            "mappingkey": "linkedBrokerCapacityID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NetPrice",
            "db_columnname": "netPrice",
            "datatype": "int",
            "mappingkey": "netPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "PairedOrderID",
            "db_columnname": "pairedOrderID",
            "datatype": "String",
            "mappingkey": "pairedOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "MultiLegInd",
            "db_columnname": "multiLegInd",
            "datatype": "String",
            "mappingkey": "multiLegInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RequestTimestamp",
            "db_columnname": "requestTimestamp",
            "datatype": "String",
            "mappingkey": "requestTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "UnderlyingSymbol",
            "db_columnname": "underlyingSymbol",
            "datatype": "String",
            "mappingkey": "underlyingSymbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "LegNum",
            "db_columnname": "legNum",
            "datatype": "int",
            "mappingkey": "legNum",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TotalLeg",
            "db_columnname": "totalLeg",
            "datatype": "int",
            "mappingkey": "totalLeg",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "LegRatioQuantity",
            "db_columnname": "legRatioQuantity",
            "datatype": "Float",
            "mappingkey": "legRatioQuantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BFMMFlag",
            "db_columnname": "bFMMFlag",
            "datatype": "char",
            "mappingkey": "bFMMFlag",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SeqNum",
            "db_columnname": "RefQuoteID",
            "datatype": "String",
            "mappingkey": "refQuoteID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AtsOrderType",
            "db_columnname": "CustomerXPPTInfo",
            "datatype": "String",
            "mappingkey": "customerXPPTInfo",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AtsDisplayInd",
            "db_columnname": "customerXPInfo1",
            "datatype": "String",
            "mappingkey": "customerXPInfo1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NbboSource",
            "db_columnname": "customerXPInfo2",
            "datatype": "String",
            "mappingkey": "customerXPInfo2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NbboTimestamp",
            "db_columnname": "DateTime1",
            "datatype": "String",
            "mappingkey": "dateTime1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OMSSystem",
            "db_columnname": "OMSSystem",
            "datatype": "String",
            "mappingkey": "oMSSystem",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "File ID",
            "db_columnname": "ClientDataHeaderID",
            "datatype": "int",
            "mappingkey": "clientDataHeaderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Created Date",
            "db_columnname": "createdDate",
            "datatype": "String",
            "mappingkey": "createdDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Updated Date",
            "db_columnname": "updatedDate",
            "datatype": "String",
            "mappingkey": "updatedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "User",
            "db_columnname": "user",
            "datatype": "String",
            "mappingkey": "user",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "CATReporterIMID",
            "db_columnname": "FirmMPID",
            "datatype": "String",
            "mappingkey": "firmMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "ElectronicDupFlag",
            "db_columnname": "ElectronicDupFlag",
            "datatype": "String",
            "mappingkey": "electronicDupFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "DeptType",
            "db_columnname": "DeptType",
            "datatype": "String",
            "mappingkey": "deptType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "ReceivingDeskType",
            "db_columnname": "ReceivingDeskType",
            "datatype": "String",
            "mappingkey": "receivingDeskType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "OrderKeyDate",
            "db_columnname": "OrderDate",
            "datatype": "String",
            "mappingkey": "orderDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "RouteId",
            "db_columnname": "RouteId",
            "datatype": "String",
            "mappingkey": "routeId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "UnLinkInd",
            "db_columnname": "UnLinkInd",
            "datatype": "String",
            "mappingkey": "unLinkInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "LegID",
            "db_columnname": "LegID",
            "datatype": "String",
            "mappingkey": "legID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "NextUnLinkInd",
            "db_columnname": "NextUnLinkInd",
            "datatype": "String",
            "mappingkey": "nextUnLinkInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "DeskOrderID",
            "db_columnname": "DeskOrderID",
            "datatype": "String",
            "mappingkey": "deskOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "PriorDeskOrderID",
            "db_columnname": "PriorDeskOrderID",
            "datatype": "String",
            "mappingkey": "priorDeskOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "Orders-Opted-Export-CSV-Grid-Columns": [
        {
            "columnName": "CATReporterIMID",
            "dbFieldValue": "FirmMPID"
        },
        {
            "columnName": "Type",
            "dbFieldValue": "EventType"
        },
        {
            "columnName": "OrderID",
            "dbFieldValue": "OrderID"
        },
        {
            "columnName": "ElectronicTimestamp",
            "dbFieldValue": "SystemDateTime"
        },
        {
            "columnName": "EventTimestamp",
            "dbFieldValue": "OrderDateTime"
        },
        {
            "columnName": "Symbol",
            "dbFieldValue": "Symbol"
        },
        {
            "columnName": "Side",
            "dbFieldValue": "BuySellCode"
        },
        {
            "columnName": "Quantity",
            "dbFieldValue": "Quantity"
        },
        {
            "columnName": "OrderType",
            "dbFieldValue": "PriceType"
        },
        {
            "columnName": "Price",
            "dbFieldValue": "LimitPrice"
        },
        {
            "columnName": "StopPrice",
            "dbFieldValue": "StopPrice"
        },
        {
            "columnName": "TimeInForce",
            "dbFieldValue": "TimeInForce"
        },
        {
            "columnName": "ExpiryDate",
            "dbFieldValue": "ExpiryDate"
        },
        {
            "columnName": "ExpiryTime",
            "dbFieldValue": "ExpiryTime"
        },
        {
            "columnName": "Initiator",
            "dbFieldValue": "CancelByCust"
        },
        {
            "columnName": "PriorOrderID",
            "dbFieldValue": "cancelOrderID"
        },
        {
            "columnName": "HandlingInstructions",
            "dbFieldValue": "SplHandlingCode"
        },
        {
            "columnName": "custDspIntrFlag",
            "dbFieldValue": "LimitOrderdisplay"
        },
        {
            "columnName": "ManualFlag",
            "dbFieldValue": "ReceiveMethod"
        },
        {
            "columnName": "NegotiatedTradeFlag",
            "dbFieldValue": "NegotiatedTrade"
        },
        {
            "columnName": "MinQty",
            "dbFieldValue": "MinQuantity"
        },
        {
            "columnName": "ElectronicDupFlag",
            "dbFieldValue": "ElectronicDupFlag"
        },
        {
            "columnName": "DeptType",
            "dbFieldValue": "DeptType"
        },
        {
            "columnName": "ReceivingDeskType",
            "dbFieldValue": "ReceivingDeskType"
        },
        {
            "columnName": "SystemGroup",
            "dbFieldValue": "OMSSystem"
        },
        {
            "columnName": "ReceivedOrderId",
            "dbFieldValue": "ReceivedOrderId"
        },
        {
            "columnName": "SenderIMID",
            "dbFieldValue": "ReceivedFromMPID"
        },
        {
            "columnName": "OrderKeyDate",
            "dbFieldValue": "OrderDate"
        },
        {
            "columnName": "RoutedOrderID",
            "dbFieldValue": "RouteId"
        },
        {
            "columnName": "AccountHolderType",
            "dbFieldValue": "CustomerType"
        },
        {
            "columnName": "RepresentativeInd",
            "dbFieldValue": "RepresentativeInd"
        },
        {
            "columnName": "AggOrderID",
            "dbFieldValue": "aggOrderId"
        },
        {
            "columnName": "IsoInd",
            "dbFieldValue": "ISOInd"
        },
        {
            "columnName": "ParentOrderID",
            "dbFieldValue": "ParentOrderID"
        },
        {
            "columnName": "CancelQty",
            "dbFieldValue": "Cancelquantity"
        },
        {
            "columnName": "TradingSession",
            "dbFieldValue": "TradingSessionCode"
        },
        {
            "columnName": "PriorUnlinked",
            "dbFieldValue": "UnLinkInd"
        },
        {
            "columnName": "LegRefID",
            "dbFieldValue": "LegID"
        },
        {
            "columnName": "PriorOrderKeyDate",
            "dbFieldValue": "CancelOrderDate"
        },
        {
            "columnName": "AffiliateFlag",
            "dbFieldValue": "AffiliateFlag"
        },
        {
            "columnName": "NextUnLinkInd",
            "dbFieldValue": "NextUnLinkInd"
        },
        {
            "columnName": "CustomerID",
            "dbFieldValue": "CustomerID"
        },
        {
            "columnName": "LeavesQty",
            "dbFieldValue": "LeavesQuantity"
        },
        {
            "columnName": "ParentOrderKeyDate",
            "dbFieldValue": "ParentOrderDate"
        },
        {
            "columnName": "SolicitationFlag",
            "dbFieldValue": "SolicitationFlag"
        },
        {
            "columnName": "TriggerPrice",
            "dbFieldValue": "TriggerPrice"
        },
        {
            "columnName": "RFQID",
            "dbFieldValue": "RefQuoteID"
        },
        {
            "columnName": "NetPrice",
            "dbFieldValue": "NetPrice"
        },
        {
            "columnName": "PairedOrderID",
            "dbFieldValue": "PairedOrderID"
        },
        {
            "columnName": "MultiLegInd",
            "dbFieldValue": "MultiLegInd"
        },
        {
            "columnName": "RequestTimestamp",
            "dbFieldValue": "RequestTimestamp"
        },
        {
            "columnName": "UnderlyingSymbol",
            "dbFieldValue": "UnderlyingSymbol"
        },
        {
            "columnName": "LegNum",
            "dbFieldValue": "LegNum"
        },
        {
            "columnName": "NumberOfLegs",
            "dbFieldValue": "TotalLeg"
        },
        {
            "columnName": "LegRatioQuantity",
            "dbFieldValue": "LegRatioQuantity"
        },
        {
            "columnName": "InfoBarrierId",
            "dbFieldValue": "InfoBarrierId"
        },
        {
            "columnName": "DeskOrderID",
            "dbFieldValue": "DeskOrderID"
        },
        {
            "columnName": "PriorDeskOrderID",
            "dbFieldValue": "PriorDeskOrderID"
        },
        {
            "columnName": "BFMMFlag",
            "dbFieldValue": "BFMMFlag"
        },
        {
            "columnName": "SeqNum",
            "dbFieldValue": "RefQuoteID"
        },
        {
            "columnName": "AtsOrderType",
            "dbFieldValue": "CustomerXPPTInfo"
        },
        {
            "columnName": "AtsDisplayInd",
            "dbFieldValue": "CustomerXPInfo1"
        },
        {
            "columnName": "NbboSource",
            "dbFieldValue": "CustomerXPInfo2"
        },
        {
            "columnName": "NbboTimestamp",
            "dbFieldValue": "DateTime1"
        }
    ]
}